import { GroupDetail } from '../../../types/groupDetail';
import { InfoColumn } from '../../shared';
import { PersonChip } from '../../shared/PersonChip';

export const getGroupInfoColumns = (groupDetail: GroupDetail): InfoColumn[] => {
  return [
    // Column 1: Leaders
    {
      fields: [
        {
          label: 'Group Leader',
          value: (
            <PersonChip 
              id={groupDetail.leader.id} 
              name={groupDetail.leader.name}
              avatarUrl={groupDetail.leader.avatarUrl}
            />
          ),
        },
        ...(groupDetail.assistantLeaders.length > 0 
          ? [{
              label: 'Assistant Leaders',
              value: (
                <div className="flex flex-wrap gap-2">
                  {groupDetail.assistantLeaders.map((leader) => (
                    <PersonChip 
                      key={leader.id}
                      id={leader.id} 
                      name={leader.name}
                      avatarUrl={leader.avatarUrl}
                    />
                  ))}
                </div>
              ),
            }]
          : []
        ),
      ],
    },
    // Column 2: Location
    {
      fields: [
        ...(groupDetail.address 
          ? [{
              label: 'Address',
              value: groupDetail.address,
            }]
          : []
        ),
        ...(groupDetail.areaOfTown 
          ? [{
              label: 'Area of Town',
              value: groupDetail.areaOfTown,
            }]
          : []
        ),
      ],
    },
    // Column 3: Schedule
    {
      fields: [
        ...(groupDetail.meetingDay 
          ? [{
              label: 'Meeting Day',
              value: groupDetail.meetingDay,
            }]
          : []
        ),
        ...(groupDetail.timeOfDay 
          ? [{
              label: 'Time of Day',
              value: groupDetail.timeOfDay,
            }]
          : []
        ),
      ],
    },
  ];
};
